/**
 * Onboarding API client for the Get Started flow.
 */

import { api } from './client';

/**
 * Create implicit structure for explorer path.
 * Creates project/story/session with defaults.
 *
 * @param {string} medium - 'novel'
 * @param {string} readiness - 'spark', 'fragments', 'concept', or 'formed'
 * @param {boolean} is_series - Whether part of a series
 * @param {string|null} series_name - Name of the series (if is_series=true)
 * @param {string|null} session_name - Custom session name (default: "Getting Started")
 * @param {string|null} template_key - Session template key (default: "open")
 * @returns {Promise<{project_id: string, story_id: string, session_id: string}>}
 */
export async function createImplicitStructure(medium, readiness = 'concept', is_series = false, series_name = null, session_name = null, template_key = null) {
  return api.post('/onboarding/implicit-structure', { medium, readiness, is_series, series_name, session_name, template_key });
}

/**
 * Create explicit structure for architect path.
 * Creates named project/story/session with provided details.
 *
 * @param {Object} params
 * @param {string} params.medium - 'novel'
 * @param {string} params.title - Working title
 * @param {string} params.pitch - One-line pitch or logline
 * @param {string} [params.readiness='formed'] - 'spark', 'fragments', 'concept', or 'formed'
 * @param {boolean} [params.is_series=false] - Whether part of a series
 * @param {string|null} [params.session_name] - Custom session name (default: "Initial Development")
 * @param {string|null} [params.template_key] - Session template key (default: "open")
 * @returns {Promise<{project_id: string, story_id: string, session_id: string, opening_message: string}>}
 */
export async function createExplicitStructure({ medium, title, pitch, readiness = 'formed', is_series = false, session_name = null, template_key = null }) {
  return api.post('/onboarding/explicit-structure', { medium, title, pitch, readiness, is_series, session_name, template_key });
}

export const onboardingApi = {
  createImplicitStructure,
  createExplicitStructure
};
